import { z } from "zod";

// en/fr/ar are required. es/it/de/nl are optional: omitted keeps what is
// stored, an empty string removes that language.
const localizedString = z.object({
  en: z.string().min(1),
  fr: z.string().min(1),
  ar: z.string().min(1),
  es: z.string().optional(),
  it: z.string().optional(),
  de: z.string().optional(),
  nl: z.string().optional(),
});

// A description is optional in every language; an empty string clears it.
const localizedOptionalString = z.object({
  en: z.string().optional(),
  fr: z.string().optional(),
  ar: z.string().optional(),
  es: z.string().optional(),
  it: z.string().optional(),
  de: z.string().optional(),
  nl: z.string().optional(),
});

export const addonVariantSchema = z.object({
  id: z.string().uuid(),
  label: z.string(),
  price: z.number().nonnegative(),
  position: z.number().int().nonnegative(),
});

export const addonSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  imageUrl: z.string().nullable(),
  position: z.number().int().nonnegative(),
  variants: z.array(addonVariantSchema),
});

export const addonVariantWriteSchema = z.object({
  id: z.string().uuid().optional(),
  label: localizedString,
  price: z.number().nonnegative(),
  position: z.number().int().nonnegative().optional(),
});

export const addonWriteSchema = z.object({
  id: z.string().uuid().optional(),
  name: localizedString,
  description: localizedOptionalString.optional(),
  imageUrl: z.string().nullable().optional(),
  position: z.number().int().nonnegative().optional(),
  variants: z.array(addonVariantWriteSchema).min(1),
});

export const setAddonsSchema = z.object({
  slug: z.string().min(1),
  addons: z.array(addonWriteSchema),
});

export const reservationAddonInputSchema = z.object({
  variantId: z.string().uuid(),
  quantity: z.number().int().positive().max(20),
});

export type Addon = z.infer<typeof addonSchema>;
export type AddonVariant = z.infer<typeof addonVariantSchema>;
export type AddonWrite = z.infer<typeof addonWriteSchema>;
export type AddonVariantWrite = z.infer<typeof addonVariantWriteSchema>;
export type SetAddonsInput = z.infer<typeof setAddonsSchema>;
export type ReservationAddonInput = z.infer<typeof reservationAddonInputSchema>;
